import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiLoadingSpinnerComponent } from '@siemens/element-ng/loading-spinner';

@Component({
  selector: 'app-feed',
  imports: [CommonModule, SiLoadingSpinnerComponent],
  templateUrl: './feed.component.html',
  styleUrl: './feed.component.scss',
})
export class FeedComponent {
  @Input() finalResponse: string | undefined;
  @Input() isExecuting?: boolean = false;
  @Input() errorMessage?: string = '';
  @Input() isUserSubmitted?: boolean = false;
}
